import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { ComingSoon } from './pages/ComingSoon';
import { placeholderPages } from './data/site';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f9yijjha2l07">
      <div className="w-full bg-white" data-id="element-1" data-mp="3fbjcp7zok1xj">
        <Header data-id="element-2" data-mp="3f8f31v3g4dzh" />
        <Routes data-id="element-3" data-mp="2rkx67l5bqppn">
          <Route path="/" element={<Home data-id="element-5" data-mp="2rloz2o7je9c8" />} data-id="element-4" data-mp="2rkdwustqp9n8" />
          {placeholderPages.map(page => <Route key={page.path} path={page.path} element={<ComingSoon title={page.title} data-id="element-7" data-mp="2mnnhk7prei2v" />} data-id="element-6" data-mp="2mmceka451ect" />)}
          <Route path="*" element={<ComingSoon title="Page Coming Soon" data-id="element-9" data-mp="31bianp7oiogh" />} data-id="element-8" data-mp="31ayr642drs0c" />
        </Routes>
        <Footer data-id="element-10" data-mp="2wjgq7g0cxrfd" />
      </div>
    </BrowserRouter>;
}